define.alias("shared/components/shared/page-picker", "media/components/shared/page-picker");